// extracted by mini-css-extract-plugin
export default {"demoContainer":"demoContainer_demoContainer__o-Qd0"};